import axios from 'axios';
import Config from '@/models/Config';
import QSUtils from '@/utils/QSUtils';
//import configJson from '../configs/dev.config.json';

export default class TheConfigService {
    private static instance: TheConfigService;
    private config: Config = {};

    private constructor() {
        //const noEmptyFunction = true;
    }

    public static getInstance(): TheConfigService {
        if (!this.instance) {
            this.instance = new TheConfigService();
        }
        return this.instance;
    }

    async getConfig(): Promise<Config> {
        if (!this.haveConfig()) {
            this.config = await this.getConfigFromFile();
        }
        return this.config as Config;
    }

    async refreshConfig(): Promise<void> {
        this.config = await this.getConfigFromFile();
    }

    private haveConfig() {
        return Object.keys(this.config).length > 0;
    }

    private async getConfigFromFile(): Promise<Config> {
        const fileData = await axios.get<Config>(`/dev.config.json?cb=${QSUtils.uuid()}`, {});
        return fileData.data;
    }
}
